<template>
  <div
    class="fixed bottom-20 right-20 text-white bg-brand rounded-10 py-10 px-19
           flex items-center hover:bg-purple-light cursor-pointer anim-color"
    :class="[showSidebar && isMobile ? '-right-350' : 'right-20']"
    @click="upgrade"
  >
    <div class="mr-5">
      <p class="text-12">You have {{ trialDaysLeft }} {{ trialDaysLeft === 1 ? 'day' : 'days' }} left on your trial.</p>
      <p class="font-medium text-16">Upgrade today</p>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({

  setup () {
    const { state, getters, commit } = useStore()

    const showSidebar = computed(() => state.settings.showSidebar)
    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)

    const trialDaysLeft = computed(() => getters.trialDaysLeft)

    function upgrade () {
      if (isMobile.value) {
        commit('toggleAside', false)
      }
      commit('changeActiveState', 'Plans')
      commit('toggleSettingsModal', true)
    }

    return {
      showSidebar,
      isMobile,
      isDarkMode,
      trialDaysLeft,
      upgrade
    }
  }
})
</script>
